import defaultPosition from "@/helpers/wc/positionSettings";

export const departmentsSettings = {
  title: "Departments",
  name: "departmentsBase",

  styles: defaultPosition,

  properties: {
    departmentType: 0,
    tags: "",
    limit: 0,
    routeName: '',
    css: {
      layout: {
        backgroundColor: "transparent",
        textAlign: "center"
      },
      departmentButton: {
        width: "200px",
        height: "50px",
        marginTop: "20px",
        marginRight: "20px",
        fontFamily: "Arial",
        fontSize: '20px',
        color: 'white',
        backgroundColor: "rgb(50, 100, 250)",
        borderColor: "blue",
        borderWidth: "2px",
        borderRadius: "10px"
      },
    }
  },
  cssLegend: {
    layout: {
      name: 'layout',
      backgroundColor: {
        type: 'color',
        name: 'background'
      },
      textAlign: {
        type: 'align',
        name: 'align'
      }
    },
    departmentButton: {
      name: 'departmentButtons',
      width: {
        type: 'int',
        name: 'width',
        handler: val => val + 'px'
      },
      height: {
        type: 'int',
        name: 'height',
        handler: val => val + 'px'
      },
      marginTop: {
        type: 'int',
        name: 'marginTop',
        handler: val => val + 'px'
      },
      marginRight: {
        type: 'int',
        name: 'marginRight',
        handler: val => val + 'px'
      },
      fontFamily: {
        type: 'fontFamily',
        name: 'fontFamily'
      },
      fontSize: {
        type: 'int',
        name: 'fontSize',
        handler: val => val + 'px'
      },
      color: {
        type: 'color',
        name: 'color'
      },
      backgroundColor: {
        type: 'color',
        name: 'background'
      },
      borderColor: {
        type: 'color',
        name: 'borderBottom'
      },
      borderWidth: {
        type: 'int',
        name: 'borderWidth',
        handler: val => val + 'px'
      },
      borderRadius: {
        type: 'int',
        name: 'borderRadius',
        handler: val => val + 'px'
      },
    }
  }
};
